module.exports = __webpack_public_path__ + "img/img08.7bc19b0c.jpeg";